import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { firebaseConnect } from 'react-redux-firebase'

const _ = require('lodash')

class DrawingDoneContainer extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        createHref: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  colorAnotherSquare() {
    const urlPath = `/drawings/${this.props.match.params.id}`
    this.context.router.history.push(urlPath)
  }

  render() {
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    const shareUrl = window.location.href.replace('/done', '')
    const emailShare = `mailto:?subject=Come create art with me!&body=I just colored part of a collaborative art piece at ${shareUrl}`
    const smsShare = `sms:?body=Come create art with me at ${shareUrl}`
    const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`
    return (
      <div className="container">
        <h2>Thanks! We'll send you a GIF once it's complete.</h2>
        <button onClick={this.colorAnotherSquare.bind(this)}>Color Another Square</button>

        <br />
        <br />
        <h2>Invite a friend to collaborate</h2>
        <input className="form-field" type="text" value={shareUrl} readOnly />
        <a className="button" style={{ marginBottom: '10px' }} href={emailShare} target="_blank">
          Email
        </a>
        {/* Only iOS Supports sms: links */
        iOS && (
          <a className="button" style={{ marginBottom: '10px' }} href={smsShare} target="_blank">
            SMS
          </a>
        )}
        <a className="button" style={{ marginBottom: '10px' }} href={fbShareUrl} target="_blank">
          Facebook
        </a>
      </div>
    )
  }
}

export default compose(
  firebaseConnect((props) => {
    // Set listeners based on props (prop is route parameter from react-router in this case)
    return [`drawings/${props.match.params.id}`]
  }),
  connect((state, props) => {
    return {
      userId: state.firebase.auth.uid,
      drawing: _.get(state.firebase.data, `drawings.${props.match.params.id}.${props.match.params.index}`),
    }
  }),
)(DrawingDoneContainer)



// WEBPACK FOOTER //
// ./src/containers/drawingDoneContainer.js